// Controls.jsx
import { Box, ButtonBase } from '@mui/material';

export function ThickChevron({ direction = 'down', ...props }) {
  const rotate = direction === 'up' ? 'rotate(180deg)' : 'none';

  return (
    <Box
      component="svg"
      viewBox="0 0 64 64"
      aria-hidden="true"
      {...props}
      sx={{
        display: 'block',
        width: { xs: 72, md: 96 },
        height: { xs: 72, md: 96 },
        transform: rotate,
        transition: 'transform .25s ease',
        ...props.sx,
      }}
    >
      <path
        d="M10 22 L32 44 L54 22"
        fill="none"
        stroke="currentColor"
        strokeWidth="9"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Box>
  );
}

export function ArrowButton({ onClick, label, sx, children }) {
  return (
    <ButtonBase
      onClick={onClick}
      aria-label={label}
      sx={{
        width: { xs: 96, md: 120 },
        height: { xs: 96, md: 120 },
        borderRadius: '50%',
        display: 'grid',
        placeItems: 'center',
        color: 'grey.300',
        transition: 'all .2s ease',
        '&:hover': {
          color: 'primary.main',
          backgroundColor: 'rgba(0,0,0,0.04)',
          transform: 'scale(1.04)',
        },
        ...sx,
      }}
    >
      {children}
    </ButtonBase>
  );
}
